import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import noum from '../components/noum.vue'
import annex from '../components/annex.vue'
import det from '../components/det.vue'
import enter from '../components/enter.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: index,
    children:[
      {
        path: '/noum',
        component: noum,
        meta:{ keepAlive: true}
      },{
        path:'/annex',
        component:annex,
        meta:{ keepAlive: true}
      },{
        path:'/det',
        component:det,
        meta:{ keepAlive: true}
      },{
        path:'/enter',
        component:enter,
        meta:{ keepAlive: true}
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
